class RebuyUpsell extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    new Swiper("[js-rebuy-upsell-slider]", {
        slidesPerView: 1,
        spaceBetween: 10,    
        navigation: {
            nextEl: "[js-rebuy-upsell-slider-next-btn]",
            prevEl: "[js-rebuy-upsell-slider-prev-btn]",
        }
    });
  }
}

customElements.define('rebuy-upsell', RebuyUpsell);